export const ADD_OPTION='ADD_OPTION'
export const ADD_OPTION_SUCCESS= 'ADD_OPTION_SUCCESS'
export const ADD_OPTION_ERROR='ADD_OPTION_ERROR'

export const CHANGE_OPTIONS_VISIBILITY='CHANGE_OPTIONS_VISIBILITY'
export const CHANGE_OPTIONS_VISIBILITY_SUCCESS= 'CHANGE_OPTIONS_VISIBILITY_SUCCESS'
export const CHANGE_OPTIONS_VISIBILITY_ERROR= 'CHANGE_OPTIONS_VISIBILITY_ERROR'

export const DELETE_OPTION='DELETE_OPTION'
export const DELETE_OPTION_SUCCESS= 'DELETE_OPTION_SUCCESS'
export const DELETE_OPTION_ERROR= 'DELETE_OPTION_ERROR'

export const DELETE_OPTIONS='DELETE_OPTIONS'
export const DELETE_OPTIONS_SUCCESS= 'DELETE_OPTIONS_SUCCESS'
export const DELETE_OPTIONS_ERROR='DELETE_OPTIONS_ERROR'

export const GET_OPTION= 'GET_OPTION'
export const GET_OPTION_SUCCESS= 'GET_OPTION_SUCCESS'
export const GET_OPTION_ERROR= 'GET_OPTION_ERROR'

export const GET_OPTIONS= 'GET_OPTIONS'
export const GET_OPTIONS_SUCCESS= 'GET_OPTIONS_SUCCESS'
export const GET_OPTIONS_ERROR='GET_OPTIONS_ERROR'


export const UNDELETE_OPTION='UNDELETE_OPTION'
export const UNDELETE_OPTION_SUCCESS= 'UNDELETE_OPTION_SUCCESS'
export const UNDELETE_OPTION_ERROR='DELETE_OPTION_ERROR'

export const UNDELETE_OPTIONS='UNDELETE_OPTIONS'
export const UNDELETE_OPTIONS_SUCCESS= 'UNDELETE_OPTIONS_SUCCESS'
export const UNDELETE_OPTIONS_ERROR= 'DELETE_OPTIONS_ERROR'

export const UPDATE_OPTION='UPDATE_OPTION'
export const UPDATE_OPTION_SUCCESS= 'UPDATE_OPTION_SUCCESS'
export const UPDATE_OPTION_ERROR= 'UPDATE_OPTION_ERROR'


export const AddOption= (data) => ({
    type: ADD_OPTION,
    payload: data
})

export const ChangeOptionsVisibility= (data) => ({
    type: CHANGE_OPTIONS_VISIBILITY,
    payload: data
})

export const DeleteOption= (data) => ({
    type: DELETE_OPTION,
    payload: data
});

export const DeleteOptions= (data) => ({
    type: DELETE_OPTIONS,
    payload: data
})

export const GetOption= (data) => ({
    type: GET_OPTION,
    payload: data
})

export const GetOptions= (data) => ({
    type: GET_OPTIONS,
    payload: data
})

export const UnDeleteOption= (data) => ({
    type: UNDELETE_OPTION,
    payload: data
})

export const UnDeleteOptions= (data) => ({
    type: UNDELETE_OPTIONS,
    payload: data
})

export const UpdateOption= (data) => ({
    type: UPDATE_OPTION,
    payload: data
})